// Creates an array of values within the low and high bounds
// Example: <div ng-repeat="n in [20, 29] | makeRange">Do something 20..29: {{n}}</div>
angular.module('components.makerange', [])
    .filter('makeRange', function () {
        return function (input) {
            var lowBound, highBound;
            switch (input.length) {
                case 1:
                    lowBound = 0;
                    highBound = parseInt(input[0]) - 1;
                    break;
                case 2:
                    lowBound = parseInt(input[0]);
                    highBound = parseInt(input[1]);
                    break;
                default:
                    return input;
            }
            var result = [];
            if (lowBound > highBound) {
                for (var i = lowBound; i >= highBound; i--) {
                    result.push(i);
                }
            } else {
                for (var i = lowBound; i <= highBound; i++) {
                    result.push(i);
                }
            }
            return result;
        };
    });